// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  worldId: __t.u64(),
  prefabKey: __t.string(),
  posX: __t.f32(),
  posY: __t.f32(),
  posZ: __t.f32(),
  rotX: __t.f32(),
  rotY: __t.f32(),
  rotZ: __t.f32(),
  rotW: __t.f32(),
  scaleX: __t.f32(),
  scaleY: __t.f32(),
  scaleZ: __t.f32(),
  physics: __t.bool(),
};
